import { ContactStatusEnum } from '@monetize/types/app';

export const CONTACT_STATUS_DISPLAY: {
  [key in ContactStatusEnum]: string;
} = {
  ACTIVE: 'Active',
  CANCELED: 'Canceled',
};

export const NEW_CONTACT = {
  id: 'NEW_CONTACT',
  fullName: '+ New Contact',
};
